import { Injectable } from '@angular/core';

import { type Credentials } from './models';

@Injectable({
  providedIn: 'root',
})
export class TokenStorage {
  private readonly STORAGE_KEY = 'auth_credentials';

  public set(data: Credentials['token']): void {
    localStorage.setItem(this.STORAGE_KEY, JSON.stringify(data));
  }

  public get(): Credentials['token'] | null {
    const raw = localStorage.getItem(this.STORAGE_KEY);

    if (!raw) {
      return null;
    }

    try {
      const parsed = JSON.parse(raw);
      return {
        key: parsed.key,
        accessExpiresAt: new Date(parsed.accessExpiresAt),
        refreshExpiresAt: new Date(parsed.refreshExpiresAt),
      };
    } catch {
      this.clear();
      return null;
    }
  }

  public clear(): void {
    localStorage.removeItem(this.STORAGE_KEY);
  }

  public hasValidSession(): boolean {
    const tokenData = this.get();
    if (!tokenData) {
      return false;
    }

    const refreshExpires = tokenData.refreshExpiresAt.getTime();
    const now = Date.now();

    return now < refreshExpires;
  }
}
